<script>
  import { createEventDispatcher } from "svelte";
  import { getPalette } from "../util/constants.js";
  // import * as transforms from "../util/transformations.js";

  const dispatch = createEventDispatcher();

  export let encoding;
  export let decoded;
  export let functions = [];

  let curPalette = getPalette({ system: encoding[0] });
  $: curPalette = getPalette({ system: encoding[0] });
</script>

<div class="container">
  {#each functions as [name, transform, byte = false]}
    <button
      class="transform-button"
      on:click={(ev) => {
        ev.preventDefault();
        if (byte) dispatch("applyByteTransform", transform);
        else dispatch("applyTransform", transform);
      }}
    >
      {name}
    </button>
  {/each}
</div>

<style>
  .container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
  }

  .transform-button {
    padding: 10px 10px;
    margin: 0;
    background: none;
    border-radius: 0;
    line-height: 1;
    border: 1px solid black;
    min-height: 30px;
  }
  .transform-button.active {
    background: black;
    color: white;
  }
</style>
